import { render, staticRenderFns } from "./purchaseRefundHistory.vue?vue&type=template&id=061f65be&scoped=true"
import script from "./purchaseRefundHistory.vue?vue&type=script&lang=js"
export * from "./purchaseRefundHistory.vue?vue&type=script&lang=js"
import style0 from "./purchaseRefundHistory.vue?vue&type=style&index=0&id=061f65be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f65be",
  null
  
)

export default component.exports